/* eslint-disable array-callback-return */
import React, { useEffect, useRef, useState } from "react";

import RationalistImg from "../../../assets/Images/RationalistImg.png";
import PerformerImg from "../../../assets/Images/PerformerImg.png";
import HarmonizerImg from "../../../assets/Images/HarmonizerImg.png";
import OptimizerImg from "../../../assets/Images/OptimizerImg.png";
import setClasssificationIcon from "../../../assets/Icons/SetClassificationIcon.svg";
import WarningMsgIcon from "../../../assets/Icons/WarningIcon.svg";

import SaleRepClassificationCard from "../../../components/SalesRepClassificationCard/salesRepClassifictationCard";

import SetClassificationQuestionaire from "./setClassificationQuestionaire";
import Buttons from "../../../components/Buttons/Buttons";
import { FormikProps } from "formik";
import {
  getAIDataForSalesPrep,
  getSalesRepClassificationList,
  saveClassicationType,
} from "../../../redux/Action/Action";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/Reducer";
import {
  POST_SAVE_FORM_DETAILS,
  SET_CLASSIFICATION_QUESTIONNAIRE,
  SET_SALES_REP_CLASSIFICATION_ID,
} from "../../../redux/Action/actionTypes";

interface Props {
  currentStep: number;
  totalSteps: number;
  goNext: () => void;
  goBack: () => void;
  isNextDisabled: boolean;
  isDetailedOverview?: boolean;
}
interface FormValues {
  Q1: string;
  Q2: string;
  Q3: string;
  Q4: string;
  Q5: string;
  Q6: string;
  Q7: string;
  Q8: string;
  Q9: string;
  Q10: string;
  Q11: string;
  Q12: string;
  Q13: string;
  Q14: string;
}

const SalesRepClassification = ({
  currentStep,
  totalSteps,
  goNext,
  goBack,
  isNextDisabled,
  isDetailedOverview = false,
}: Props) => {
  const [isShowClassification, setIsShowClassification] = useState(false);
  const [isSkipSalesRep, setIsSkipSalesRep] = useState<boolean>(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState<boolean>(true);
  const [cardSelected, setCardSelected] = useState<string>("");
  const [showAIRecommendation, setShowAIRecommendation] =
    useState<boolean>(false);
  const aiSalesRepData = useSelector(
    (state: RootState) => state.salesRepClassification.aiClassificationData
  );
  const salesRepClassificationListArr = useSelector(
    (state: RootState) =>
      state.salesRepClassification.salesRepClassificationList
  );
  const isFormUpdate = useSelector(
    (state: RootState) => state.basicDetails.formState
  );
  const classificationTypeData = useSelector(
    (state: RootState) => state.salesRepClassification.classificationType
  );
  const formikRef = useRef<FormikProps<FormValues | null>>(null);
  const basicDetailsData = useSelector(
    (state: RootState) => state.basicDetails
  );
  const powerPositionDetails = useSelector(
    (state: RootState) => state.powerPosition
  );
  const TargetValuenData = useSelector(
    (state: RootState) => state.TargetValue.TargetValueData
  );
  const salesRepClassificationData = useSelector(
    (state: RootState) => state.salesRepClassification
  );
  const dispatch = useDispatch();

  // skip handler for skiping the sales rep selection
  const skipHandler = (goForward: boolean = false) => {
    if (currentStep === 2 && !goForward && classificationTypeData === "") {
      setIsSkipSalesRep(true);
    } else {
      setIsSkipSalesRep(false);
      goNext();
    }
  };

  // submit hanlder for sales rep classification questionnaire
  const submitHandler = () => {
    setIsShowClassification(false);
    if (formikRef.current) {
      formikRef.current.submitForm();
    }
    setShowAIRecommendation(false);
  };

  // sales rep card content array for different sales rep
  const cardContentArr = [
    [
      "Well prepared",
      "Fact oriented",
      "Proud of product and expertise",
      "In control of his/her emotions",
    ],
    [
      "Well prepared",
      "Relationship oriented",
      "Knows to adapt",
      "Talks powerful, yet chooses words carefully",
    ],
    [
      "No detailed preparation",
      "Relationship oriented",
      "Good listener",
      "Takes a moment to think before speaking",
    ],
    [
      "No detailed preparation",
      "Fact oriented",
      "Rather impulsive",
      "Talks spontaneously without much thought",
    ],
  ];

  // updating the sales rep id after type selection
  const classificationTypeIdHandler = (typeName: string) => {
    let selectedCardId: any = "";
    salesRepClassificationListArr.length > 0 &&
      salesRepClassificationListArr.map((obj: any) => {
        if (obj.title === typeName) {
          selectedCardId = obj.id;
        }
      });
    dispatch({
      type: SET_SALES_REP_CLASSIFICATION_ID,
      payload: selectedCardId,
    });
  };

  // saving the classification type after selection
  const classificationTypeSave = (typeName: string) => {
    if (typeName === cardSelected) {
      setCardSelected("");
      dispatch(saveClassicationType(""));
      dispatch({ type: SET_SALES_REP_CLASSIFICATION_ID, payload: "" });
    } else {
      setCardSelected(typeName);
      dispatch(saveClassicationType(typeName));
      classificationTypeIdHandler(typeName);
    }
  };

  // save method for draft
  const saveHandler = () => {
    isShowClassification &&
      dispatch({
        type: SET_CLASSIFICATION_QUESTIONNAIRE,
        payload: formikRef.current?.values,
      });
    dispatch({
      type: POST_SAVE_FORM_DETAILS,
      payload: {
        basicDetailsData: basicDetailsData?.basicDetailsData,
        powerPositionDetails,
        salesRepClassificationData: isShowClassification
          ? {
              classificationSettings: formikRef.current?.values,
              classificationType: classificationTypeData,
            }
          : salesRepClassificationData,
        TargetValuenData,
        isFormUpdate,
      },
    });
  };

  // setting the classification data after retrieving the sales rep datafrom  get api
  useEffect(() => {
    if (classificationTypeData !== "") {
      setCardSelected(classificationTypeData);
    }
  }, [classificationTypeData]);

  // calling ai suggestion menthod after clicking on check AI recommendation button
  const aiSuggestionHandler = () => {
    let payload = {
      SalesRepName: "",
      RequestSource: "SalesRep",
      Supplier: "",
    };
    let basicDetails = basicDetailsData.basicDetailsData;

    basicDetailsData.salesRepLeadData.map((obj: any) => {
      if (obj?.value === basicDetails.salesRepLead) {
        payload.SalesRepName = obj?.name;
      }
    });
    basicDetailsData.suppliersData.map((obj: any) => {
      if (obj?.value === basicDetails.suppliers) {
        payload.Supplier = obj?.name;
      }
    });
    dispatch(getAIDataForSalesPrep(payload));
  };

  // after fetching data form AI api , updating the type and AI message
  useEffect(() => {
    if (
      Object.keys(aiSalesRepData).length > 0 &&
      ["Performer", "Rationalist", "Harmonizer", "Optimizer", null].includes(
        aiSalesRepData?.salesRepClassification
      )
    ) {
      setShowAIRecommendation(true);
      classificationTypeIdHandler(aiSalesRepData?.salesRepClassification);
    } else if (aiSalesRepData?.response) {
      setShowAIRecommendation(true);
    }
  }, [aiSalesRepData]);

  // calling list of ID's for all sales rep classification type
  useEffect(() => {
    if (salesRepClassificationListArr.length == 0) {
      dispatch(getSalesRepClassificationList());
    }
  }, [salesRepClassificationListArr]);

  return (
    <>
      {isShowClassification ? (
        <SetClassificationQuestionaire
          setIsSubmitDisabled={setIsSubmitDisabled}
          setRefInstance={(instance: any) => (formikRef.current = instance)}
          classificationTypeIdHandler={classificationTypeIdHandler}
        />
      ) : (
        <div className="salesRepClassificationContainer">
          {isDetailedOverview ? null : (
            <>
              <p className="salesRepContent">
                Determine the <u>negotiation strategy</u> of the sales rep you
                are negotiating with.
              </p>
              <div className="row alignment-style-AI-classification-button">
                <div className="col-3 offset-3">
                  <div
                    className="setClassificationBox alignmentStyle"
                    onClick={() => setIsShowClassification(true)}
                    role="button"
                  >
                    <img
                      src={setClasssificationIcon}
                      alt="Set Classification Icon"
                    />
                    {"Set Classification"}
                  </div>
                </div>
                <div
                  className="col-3"
                  onClick={aiSuggestionHandler}
                  role="button"
                >
                  <div className="ai-suggestion-box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#FFF"
                      className="bi bi-magic"
                      viewBox="0 0 16 16"
                    >
                      <path d="M9.5 2.672a.5.5 0 1 0 1 0V.843a.5.5 0 0 0-1 0zm4.5.035A.5.5 0 0 0 13.293 2L12 3.293a.5.5 0 1 0 .707.707zM7.293 4A.5.5 0 1 0 8 3.293L6.707 2A.5.5 0 0 0 6 2.707zm-.621 2.5a.5.5 0 1 0 0-1H4.843a.5.5 0 1 0 0 1zm8.485 0a.5.5 0 1 0 0-1h-1.829a.5.5 0 0 0 0 1zM13.293 10A.5.5 0 1 0 14 9.293L12.707 8a.5.5 0 1 0-.707.707zM9.5 11.157a.5.5 0 0 0 1 0V9.328a.5.5 0 0 0-1 0zm1.854-5.097a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L8.646 5.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0l1.293-1.293Zm-3 3a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L.646 13.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0z" />
                    </svg>
                    <div className="ai-suggestion-text">
                      Check AI Recommendation
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {showAIRecommendation && (
            <div className="row align-items-stretch ai-recommendation-text-box">
              <div className="col-md-1">
                <img
                  src={WarningMsgIcon}
                  width="40px"
                  height="40px"
                  alt="Warning icon"
                />
              </div>
              <div className="col-md-10 col-sm-12 ai-recommendation-content">
                {aiSalesRepData?.response ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: aiSalesRepData.response,
                    }}
                  />
                ) : null}
              </div>
              <div className="col-md-1">
                <svg
                  onClick={() => setShowAIRecommendation(!showAIRecommendation)}
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#EA9516"
                  className="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                </svg>
              </div>
            </div>
          )}
          <div className="row min-height">
            <div className="col-sm-12 col-md-6 col-lg-3  ">
              <SaleRepClassificationCard
                classList={"card1"}
                cardImg={RationalistImg}
                cardHeading="Rationalist"
                subHeading="“The truth of the story lies in the details”"
                cardContent={cardContentArr[0]}
                cardSelected={cardSelected}
                cardHandler={() => classificationTypeSave("Rationalist")}
              />
            </div>
            <div className="col-sm-12 col-md-6 col-lg-3  ">
              <SaleRepClassificationCard
                classList={"card2"}
                cardImg={PerformerImg}
                cardHeading="Performer"
                subHeading="“Don’t let anything stop you from reaching your goals”"
                cardContent={cardContentArr[1]}
                cardSelected={cardSelected}
                cardHandler={() => classificationTypeSave("Performer")}
              />
            </div>
            <div className="col-sm-12 col-md-6 col-lg-3  ">
              <SaleRepClassificationCard
                classList={"card3"}
                cardImg={HarmonizerImg}
                cardHeading="Harmonizer"
                subHeading="“Keep calm to achieve your goals”"
                cardContent={cardContentArr[2]}
                cardSelected={cardSelected}
                cardHandler={() => classificationTypeSave("Harmonizer")}
              />
            </div>
            <div className="col-sm-12 col-md-6 col-lg-3  ">
              <SaleRepClassificationCard
                classList={"card4"}
                cardImg={OptimizerImg}
                cardHeading="Optimizer"
                subHeading="“Minimal efforts to achieve given goals”"
                cardContent={cardContentArr[3]}
                cardSelected={cardSelected}
                cardHandler={() => classificationTypeSave("Optimizer")}
              />
            </div>
          </div>
          {isDetailedOverview ? null : (
            <div className="row">
              <div className="col-12 alignment-style-read-more">
                <a
                  href="/negotiation_strategy_types_details.pdf"
                  target="_blank"
                >
                  Read more about the differences between the negotiation
                  strategies!
                </a>
              </div>
            </div>
          )}
        </div>
      )}
      {isDetailedOverview ? null : (
        <Buttons
          currentStep={currentStep}
          totalSteps={totalSteps}
          goNext={goNext}
          goBack={goBack}
          isNextDisabled={false}
          isSkipSalesRep={isSkipSalesRep}
          setIsSkipSalesRep={setIsSkipSalesRep}
          skipHandler={skipHandler}
          isShowClassification={isShowClassification}
          setIsShowClassification={setIsShowClassification}
          submitHandler={submitHandler}
          isSubmitDisabled={isSubmitDisabled}
          saveHandler={saveHandler}
        />
      )}
    </>
  );
};

export default SalesRepClassification;
